import { Box } from '@mui/system'
import React from 'react'
import { useSelector } from 'react-redux'
import ChartWidget from './ChartWidget/ChartWidget'
import Positions from './Positions/Positions'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import { selectSelectedAssetTitle } from '../../../store/redusers/assets/selectors'

const DashboardContent = () => {
	const selectedAssetTitle = useSelector(selectSelectedAssetTitle)
	const { mdUp } = useDefaultComponentTools()
	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			gap: mdUp ? '16px' : '8px',
			height: '100%',
			overflow: 'hidden'}}
		>
			<Box sx={{height: mdUp ? '55%' : '450px'}}>
				{!selectedAssetTitle ? null : <ChartWidget assetTitle={selectedAssetTitle} />}
			</Box>
			<Box  sx={{height: mdUp ? '45%' : 'auto'}}>
				<Positions />
			</Box>
		</Box>
	)
}

export default DashboardContent
